import './App.css'
import React, { Suspense, useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './assets/scss/index.scss'
import './bootstrap.min.css'
import './common.scss'
import './inputCommon.scss'
import './selectCommon.scss'
import './tableCommon.scss'
import './modalCommon.scss'
import './buttonCommon.scss'
import './main.scss'
import './dropDownCommon.scss'
import { MetadataAndConfigProvider } from './context/MetadataAndConfig'
import { PATH } from './constants/router'
import ROUTERS from './router'

function App() {
  const themeApp = process.env.REACT_APP_THEME_NAME || 'default'

  useEffect(() => {
    document.body.setAttribute('data-theme', themeApp)

    const loadingScreen = document.querySelector('.splash-screen-loading')
    if (loadingScreen) {
      loadingScreen.style.display = 'none'
    }
  }, [themeApp])

  return (
    <MetadataAndConfigProvider>
      <Router basename="/">
        <Switch>
          {Object.keys(ROUTERS).map((key) => {
            const CurrentComponent = ROUTERS[key].component

            return (
              <Route
                key={key}
                exact
                path={ROUTERS[key].path}
                render={(props) => (
                  <Suspense fallback={<div className="loading">Loading...</div>}>
                    <CurrentComponent {...props} />
                  </Suspense>
                )}
              />
            )
          })}
          <Redirect to={PATH.HOME} />
        </Switch>
      </Router>
    </MetadataAndConfigProvider>
  )
}

export default App